import React from 'react';
import { object } from 'prop-types';
import classNames from 'classnames/bind';

import Wysiwyg from 'components/Wysiwyg';
import InfoGrayBox from 'components/InfoGrayBox';

import WithBlurPopin from 'containers/WithBlurPopin';
import { withLabels } from 'containers/withLabels';
import { withErrorBoundary } from 'containers/ErrorBoundary';

import styles from './InstructionsContent.module.scss';
const cx = classNames.bind(styles);

const InstructionsContent = ({ data, labels }) => (
  <div className={cx('container')}>
    {data.title && <h1 className={cx('title')}>{data.title}</h1>}
    {data.short_description && (
      <div className={cx('short-description')}>{data.short_description}</div>
    )}

    <WithBlurPopin>
      <InfoGrayBox data={data} title={labels.instructionInfoTitle} />

      {data.body && (
        <div className={cx('body-list')}>
          {!!data.body.fi_applications.length && (
            <section className={cx('item')}>
              <h2 className={cx('title')}>
                {labels.instructionApplicationsLabel}
              </h2>
              {data.body.fi_applications.map((item, index) => (
                <Wysiwyg key={index} text={item} />
              ))}
            </section>
          )}
          {!!data.body.fi_caution.length && (
            <section className={cx('item')}>
              <h2 className={cx('title')}>{labels.instructionCautionLabel}</h2>
              {data.body.fi_caution.map((item, index) => (
                <Wysiwyg key={index} text={item} />
              ))}
            </section>
          )}
          {!!data.body.fi_fitting_instructions.length && (
            <section className={cx('item')}>
              <h2 className={cx('title')}>{labels.instructionFittingLabel}</h2>
              {data.body.fi_fitting_instructions.map((item, index) => (
                <Wysiwyg key={index} text={item} />
              ))}
            </section>
          )}
          {!!data.body.fi_after_the_assembly.length && (
            <section className={cx('item')}>
              <h2 className={cx('title')}>
                {labels.instructionAfterAssemblyLabel}
              </h2>
              {data.body.fi_after_the_assembly.map((item, index) => (
                <Wysiwyg key={index} text={item} />
              ))}
            </section>
          )}
        </div>
      )}
    </WithBlurPopin>
  </div>
);

InstructionsContent.propTypes = {
  data: object.isRequired,
  labels: object.isRequired,
};

export default withLabels(withErrorBoundary(InstructionsContent));



// WEBPACK FOOTER //
// ./src/pages/FittingInstructions/components/InstructionsContent/InstructionsContent.js